import React, { useState, useEffect, useContext } from 'react';
import { Container, Box, TextField, Button, Dialog, DialogContent, DialogTitle, DialogActions, Grid, MenuItem, IconButton, InputAdornment, Tooltip, Typography, Tabs, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Stack, Accordion, AccordionSummary, AccordionDetails, Checkbox, FormControl, Select, Grow } from '@mui/material';
import Swal from 'sweetalert2';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import SearchIcon from '@mui/icons-material/Search';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import axios from 'axios';
import ReusableTable from '../components/tables/resuabletable';
import * as XLSX from 'xlsx';
import { AuthContext } from '..';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { format } from 'date-fns/format';
import FollowUps from './followups';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import Autocomplete from '@mui/material/Autocomplete';
import DownloadIcon from '@mui/icons-material/Download'

export default function Leads() {
  const [columns, setColumns] = useState([]);
  const [rows, setRows] = useState([]);
  const [openLeadDialog, setOpenLeadDialog] = useState(false);
  const [openCustomDialog, setOpenCustomDialog] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [followUps, setFollowUps] = useState([]);
  const [editingLeadId, setEditingLeadId] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [employeelist, setEmployeelist] = useState([]);
  const { companyid, sourceTypeData, interestLevelData, leadStageData, permissions, selfOnly, employeeId, token } = useContext(AuthContext);
  const [editicon, setEditicon] = useState(true);
  const [deleteicon, setDeleteicon] = useState(true);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [tab, setTab] = useState({ value: '4' });
  const [opencolspaper, setOpencolspaper] = useState(false);
  const [columnOrder, setColumnOrder] = useState([]);
  const [selectedIds, setSelectedIds] = useState([]);
  const [openAssignmentDialog, setOpenAssignmentDialog] = useState(false);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [appliedFilters, setAppliedFilters] = useState([]);


  const filteredColumns = columnOrder
    .map(field => columns.find(col => col.field === field))
    .filter(col => col && !col.hide);

  const [pagination, setPagination] = useState({
    page: 0,
    rowsPerPage: 25,
  });
  const [totalrows, setTotalrows] = useState(0);

  const handlePaginationChange = (paginationData) => {
    setPagination(paginationData);
  };

  const getLeadButtonLabel = (editingLeadId, tab) => {
    if (!editingLeadId) return "Submit Lead";
    if (tab == 1) return "Update Lead";
    if (tab == 2) return "Make Active";
    if (tab == 3) return "Convert to Lead";
    return "Update Lead";
  };

  const [formData, setFormData] = useState({
    companyid: '',
    leadName: '',
    fullName: '',
    email: '',
    phone: '',
    alternateNumber: '',
    address: '',
    city: '',
    state: '',
    country: '',
    zipCode: '',
    sourceType: '',
    sourceChannel: '',
    interestLevel: '',
    leadStage: '',
    assignedTo: '',
    assignedOn: null,
    notes: ''
  });
  const [activeTab, setActiveTab] = useState(0);
  const [errors, setErrors] = useState({});

  const validate = () => {
    const newErrors = {};
    if (!formData.leadName) newErrors.leadName = "Lead name is required";
    if (!formData.fullName) newErrors.fullName = "Full name is required";
    if (!formData.email) newErrors.email = "Email is required";
    if (!formData.phone) newErrors.phone = "Phone is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const permissionsaccess = () => {
    const leadsmodule = permissions.leads || {};
    setDeleteicon(leadsmodule.delete === true);
    setEditicon(leadsmodule.update === true);
    if (!leadsmodule.read) {
      setActiveTab(1);
    }
  };

  const refreshData = () => {
    // if (!companyid) return;

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/countries`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => setCountries(res.data))
      .catch(err => { console.error('Failed to fetch countries:', err); });

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/states`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => setStates(res.data))
      .catch(err => console.error('Failed to fetch states:', err));

    axios.get(`${process.env.REACT_APP_API_LINKS}/locationsmaster/cities`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true
      }
    )
      .then(res => setCities(res.data))
      .catch(err => console.error('Failed to fetch cities:', err));
  };

  useEffect(() => {
    if (companyid) {
      setFormData(prev => ({
        ...prev,
        companyid: companyid
      }));
      fetchLeads();
      roles();
      refreshData();
    }
  }, [companyid, tab, pagination, appliedFilters]);

  useEffect(() => {
    if (permissions && permissions.leads && permissions.followup) {
      permissionsaccess();
    }
  }, [permissions]);

  useEffect(() => {
    if (tab.value == 1) {
      setDeleteicon(false);
      setEditicon(false);
    } else {
      setDeleteicon(true);
      setEditicon(true);
    }
  }, [tab]);

  const roles = () => {
    axios.get(`${process.env.REACT_APP_API_LINKS}/employees/getemployees`,
      {
        headers: {
          Authorization: `bearer ${token}`
        },
        withCredentials: true
      }
    )
      .then((res) => {
        setEmployeelist(res.data.data);
      })
      .catch((error) => {
        console.error('Error fetching employees:', error);
      });
  };

  const fetchFollowUps = (leadId) => {
    axios
      .get(`${process.env.REACT_APP_API_LINKS}/followups/getcompanyfollowups/${leadId}`, { withCredentials: true })
      .then((res) => {
        const followUps = res.data?.data || [];
        const formattedFollowUps = followUps.map(followUp => ({
          ...followUp,
          followUpDate: followUp.followUpDate
            ? format(new Date(followUp.followUpDate), 'dd/MM/yyyy')
            : '-',
          nextFollowUpDate: followUp.nextFollowUpDate
            ? format(new Date(followUp.nextFollowUpDate), 'dd/MM/yyyy')
            : '-',
          status: followUp.status || '-',
          notes: followUp.notes || '-'
        }));
        setFollowUps(formattedFollowUps);
      })
      .catch((error) => {
        console.error('Error fetching follow-ups:', error);
        setFollowUps([]);
      });
  };

  const handleLeadNameClick = (lead) => {
    setSelectedLead(lead);
    setOpenCustomDialog(true);
    fetchFollowUps(lead.id);
  };

  const handleCloseCustomDialog = () => {
    setOpenCustomDialog(false);
    setSelectedLead(null);
    setFollowUps([]);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === 'checkbox' ? checked : value });
  };

  const handleDateChange = (name, date) => {
    setFormData({ ...formData, [name]: date });
  };

  const handleLeadSubmit = () => {
    if (!validate()) {
      return;
    }

    const formattedData = {
      ...formData,
      companyid: companyid,
      assignedOn: formData.assignedOn ? format(formData.assignedOn, 'dd-MM-yyyy') : null
    };
    const tabid = tab.value;

    if (editingLeadId) {
      axios.put(`${process.env.REACT_APP_API_LINKS}/leads/updatelead/${editingLeadId}/${tabid}`, formattedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then((res) => {
          if (res.status === 200) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Lead updated successfully',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            });
            setOpenLeadDialog(false);
            setEditingLeadId(null);
            fetchLeads();
          }
        })
        .catch((err) => {
          Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Failed to update lead. Try again later.',
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true
          });
        });
    } else {
      axios.post(`${process.env.REACT_APP_API_LINKS}/leads/addlead`, formattedData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        }
      )
        .then((res) => {
          if (res.status === 201) {
            Swal.fire({
              icon: 'success',
              title: 'Success',
              text: 'Lead added successfully',
              showConfirmButton: false,
              timer: 1500,
              timerProgressBar: true
            });
            setOpenLeadDialog(false);
            fetchLeads();
          }
        })
        .catch((err) => {
          if (err.response && err.response.status === 409) {
            Swal.fire({
              icon: 'warning',
              title: 'Duplicate Lead',
              text: 'Lead with same name or email already exists',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true
            });
          } else {
            Swal.fire({
              icon: 'error',
              title: 'Error',
              text: 'Failed to add lead. Try again later.',
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true
            });
          }
        });
    }
  };

  const handleEdit = (lead) => {
    const getIdFromValue = (list, value) => {
      const match = list?.find(item => item.value.toLowerCase() === value?.toLowerCase());
      return match ? match.id : '';
    };

    const getEmployeeIdFromName = (name) => {
      const match = employeelist.find(item => item.employee_name.toLowerCase() === name?.toLowerCase());
      return match ? match.id : '';
    };

    const getLocationId = (list, name) => {
      if (!name) return '';
      const match = list.find(item => item.name.toLowerCase() === name.toLowerCase());
      return match ? match.id : '';
    };

    setFormData({
      leadName: lead.lead_name || '',
      fullName: lead.full_name || '',
      email: lead.email || '',
      phone: lead.phone || '',
      alternateNumber: lead.alternate_number || '',
      address: lead.address || '',
      city: getLocationId(cities, lead.city),
      state: getLocationId(states, lead.state),
      country: getLocationId(countries, lead.country),
      zipCode: lead.zip_code || '',
      sourceType: getIdFromValue(sourceTypeData, lead.source_type),
      sourceChannel: lead.source_channel || '',
      interestLevel: getIdFromValue(interestLevelData, lead.interest_level),
      leadStage: getIdFromValue(leadStageData, lead.lead_stage),
      assignedTo: getEmployeeIdFromName(lead.assigned_to),
      assignedOn: lead.assigned_on ? new Date(lead.assigned_on) : null,
      notes: lead.notes || ''
    });

    setEditingLeadId(lead.id);
    setOpenLeadDialog(true);
  };

  const handleDelete = (lead) => {
    const tabid = tab.value;
    Swal.fire({
      title: `Are you sure you want to delete lead "${lead.lead_name}"?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'Cancel'
    }).then((result) => {
      if (result.isConfirmed) {
        axios.delete(`${process.env.REACT_APP_API_LINKS}/leads/deletelead/${lead.id}/${tabid}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        })
          .then(() => {
            Swal.fire('Deleted!', 'Lead has been deleted.', 'success');
            fetchLeads();
          })
          .catch(() => {
            Swal.fire('Error!', 'Failed to delete lead.', 'error');
          });
      }
    });
  };

  const handleSearch = (e) => {
    setSearchQuery(e.target.value.toLowerCase());
  };

  const filteredRows = rows
    .filter((row) => {
      const leadName = row.lead_name?.toLowerCase() || '';
      const email = row.email?.toLowerCase() || '';
      const leadStage = row.lead_stage?.toLowerCase() || '';
      const interestLevel = row.interest_level?.toLowerCase() || '';
      const nextFollowUp = row.display_nextFollowUp?.toLowerCase() || '';

      return (
        leadName.includes(searchQuery) ||
        email.includes(searchQuery) ||
        leadStage.includes(searchQuery) ||
        interestLevel.includes(searchQuery) ||
        nextFollowUp.includes(searchQuery)
      );
    })
    .map((row) => {
      const filteredRow = { ...rows };
      filteredColumns.forEach((col) => {
        filteredRow[col.field] = row[col.field] || '';
      });
      return filteredRow;
    });

  const fetchLeads = () => {
    const payload = {
      filters: JSON.stringify(appliedFilters),
      currentpage: pagination.page,
      rowsPerPage: pagination.rowsPerPage,
      selfOnly: selfOnly,
      employeeid: employeeId
    };
    const tabid = tab.value;

    axios.get(`${process.env.REACT_APP_API_LINKS}/leads/getleads/${tabid}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: payload,
      withCredentials: true
    })
      .then((res) => {
        const newColumns = res.data.columns.map((col) => {
          if (col.field === "next_follow_up") return { ...col, field: "display_nextFollowUp" };
          return col;
        });
        setColumns(newColumns);
        setColumnOrder(newColumns.filter(col => !col.hide).map(col => col.field));
        var numberofleads = res.data.totalrows[0];
        setTotalrows(numberofleads.totalusers);
        const formattedRows = res.data.data.map(lead => ({
          ...lead,
          // assignedOn: lead.assigned_on ? format(new Date(lead.assigned_on), 'dd/MM/yyyy') : '',
          created_on: lead.created_on ? format(new Date(lead.created_on), 'dd/MM/yyyy') : '',
          // nextFollowUp: lead.next_follow_up ? format(new Date(lead.next_follow_up), 'yyyy-MM-dd') : '',
          // display_nextFollowUp: lead.next_follow_up ? format(new Date(lead.next_follow_up), 'dd/MM/yyyy') : ''
        }));
        setRows(formattedRows);

      })
      .catch((error) => {
        console.error('Error fetching leads:', error);
      });
  };

  const formatLeadsData = (rows) => {
    return rows.map((row, index) => {
      const formattedRow = { S_No: index + 1 };
      filteredColumns.forEach((col) => {
        if (col.headerName === 'S.No') return;
        formattedRow[col.headerName || col.field] = row[col.field] || '';
      });
      return formattedRow;
    });
  };

  const exportToExcel = () => {
    const rowsToExport = selectedIds.length > 0
      ? filteredRows.filter(row => selectedIds.includes(row.id))
      : filteredRows;

    const exportData = formatLeadsData(rowsToExport);
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Leads');
    XLSX.writeFile(workbook, 'leads_data.xlsx');
  };

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setAppliedFilters([]);
    setTab({ value: '4' })
  };

  const handleFileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (evt) => {
      try {
        const data = new Uint8Array(evt.target.result);
        const workbook = XLSX.read(data, { type: 'array' });
        const worksheet = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]]);

        if (!worksheet.length) {
          return Swal.fire('Error', 'Excel sheet is empty', 'error');
        }

        const response = await axios.post(`${process.env.REACT_APP_API_LINKS}/leads/bulkaddleads`, { leads: worksheet, companyid: companyid }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });

        if (response.status === 201 || response.status === 200) {
          Swal.fire('Success', 'Bulk leads imported successfully', 'success');
          fetchLeads();
        }
      } catch (error) {
        console.error('Bulk upload error:', error);
        Swal.fire('Error', 'Failed to import leads. Please check the file format.', 'error');
      }
    };

    reader.readAsArrayBuffer(file);
    refreshData();
  };

  const handleBulkAssignment = async () => {
    if (!selectedEmployee) return;

    const tabid = tab.value;

    try {
      for (const id of selectedIds) {
        await axios.put(`${process.env.REACT_APP_API_LINKS}/leads/updateBulkAssignment/${id}/${tabid}`, { assignedTo: selectedEmployee.id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          withCredentials: true,
        });
      }
      Swal.fire('Success', 'Assignments updated successfully', 'success');
      setOpenAssignmentDialog(false);
      setSelectedEmployee(null);
      fetchLeads();
    } catch (error) {
      Swal.fire('Error', 'Failed to update assignments', 'error');
    }
  };

  return (
    <Container
      disableGutters
      maxWidth={false}
      sx={{
        px: { xs: 2, sm: 3, md: 4 },
        py: 3,
        fontFamily: 'Open Sans',
        backgroundColor: '#ffffff',
        minHeight: 'calc(100vh - 64px)',
        borderRadius: 3,
        boxShadow: '0px 0px 5px rgba(187, 222, 241, 0.9)',
        mx: 'auto'
      }}
    >
      <Box sx={{ mb: 3 }}>
        <Tabs value={activeTab} onChange={handleTabChange} textColor="primary" indicatorColor="primary">
          {permissions?.leads?.read && <Tab label="Leads" sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, minWidth: 'auto' }} />}
          {permissions?.followup?.read && <Tab label="Follow-ups" sx={{ fontSize: { xs: '10px', sm: '12px', md: '14px' }, minWidth: 'auto' }} />}
        </Tabs>
      </Box>

      {activeTab === 0 ? (
        <>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'column', lg: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            mb: 3,
            gap: 2
          }}>
            <TextField
              placeholder="Search by Lead Name, Email, or Lead Stage"
              size="small"
              variant="outlined"
              sx={{ minWidth: 310, width: { sm: '100%', md: '100%', lg: 500 } }}
              value={searchQuery}
              onChange={handleSearch}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
            />
            <Box sx={{
              display: 'flex',
              flexDirection: { xs: 'column', sm: 'row' },
              alignItems: { xs: 'flex-start', sm: 'center' },
              justifyContent: { md: 'space-between', sm: 'space-between' },
              gap: 2,
              width: { xs: '100%', sm: '100%', md: '100%', xs: '100%' },
            }}>
              <FormControl size="small" sx={{ width: { lg: 160, md: 400, sm: 400, xs: '100%' } }}>
                <Select
                  value={tab.value}
                  onChange={(e) => setTab(prev => ({ ...prev, value: e.target.value }))}
                  sx={{
                    fontSize: '12px',
                    '& .MuiSelect-select': {
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      gap: 1,
                      fontFamily: 'Open Sans',
                      fontSize: '13px',
                    }
                  }}
                >
                  <MenuItem
                    value="4"
                    sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                  >
                    <span style={{ fontFamily: "Open Sans", fontSize: "13px" }}>Pipeline</span>
                    <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "blue" }} />
                  </MenuItem>
                  <MenuItem
                    value="1"
                    sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                  >
                    <span style={{ fontFamily: "Open Sans", fontSize: "13px" }}>Active</span>
                    <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "green" }} />
                  </MenuItem>
                  <MenuItem
                    value="2"
                    sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                  >
                    <span style={{ fontFamily: "Open Sans", fontSize: "13px" }}>Inactive</span>
                    <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "red" }} />
                  </MenuItem>
                  <MenuItem
                    value="3"
                    sx={{ display: "flex", alignItems: "center", gap: 1, justifyContent: 'space-between' }}
                  >
                    <span style={{ fontFamily: "Open Sans", fontSize: "13px" }}>Draft</span>
                    <Box sx={{ width: 7, height: 7, borderRadius: "50%", backgroundColor: "yellow" }} />
                  </MenuItem>
                </Select>
              </FormControl>
              <Box sx={{
                display: 'flex',
                flexDirection: { xs: 'row', sm: 'row' },
                gap: { xs: 1, sm: 2 },
                width: { xs: '100%', md: '100%', sm: '100%' },
                justifyContent: { lg: 'flex-end', md: 'flex-end', sm: 'flex-end', xs: 'space-between' },
                alignItems: 'center',
              }}>
                {permissions?.leads?.create && <Button
                  variant="contained"
                  startIcon={<AddIcon />}
                  onClick={() => {
                    setFormData({
                      companyid: companyid,
                      leadName: '',
                      fullName: '',
                      email: '',
                      phone: '',
                      alternateNumber: '',
                      address: '',
                      city: '',
                      state: '',
                      country: '',
                      zipCode: '',
                      sourceType: '',
                      sourceChannel: '',
                      interestLevel: '',
                      leadStage: '',
                      assignedTo: '',
                      assignedOn: null,
                      notes: ''
                    });
                    setEditingLeadId(null);
                    setOpenLeadDialog(true);
                  }}
                  sx={{
                    backgroundColor: '#0b85c8',
                    fontFamily: 'Open Sans',
                    borderRadius: 2,
                    whiteSpace: 'nowrap',
                    minWidth: 'fit-content',
                    fontSize: { xs: '12px' },
                    width: { xs: 'auto', sm: 'auto' }
                  }}
                >
                  Add Lead
                </Button>}
                <Tooltip title="Export to Excel" arrow>
                  <IconButton onClick={exportToExcel}>
                    <DownloadIcon sx={{ color: '#0b85c8' }} />
                  </IconButton>
                </Tooltip>
                <input
                  accept=".xlsx,.xls"
                  style={{ display: 'none' }}
                  id="bulk-upload"
                  type="file"
                  onChange={handleFileUpload}
                />
                <label htmlFor="bulk-upload">
                  <Tooltip arrow title="Bulk Import">
                    <IconButton component="span" sx={{ color: '#0b85c8' }}>
                      <CloudUploadIcon sx={{ color: '#0b85c8' }} />
                    </IconButton>
                  </Tooltip>
                </label>
                <Tooltip title="Customize Columns" arrow>
                  <IconButton
                    onClick={() => setOpencolspaper(true)}
                    sx={{ color: '#0b85c8', padding: '8px' }}
                  >
                    <ViewColumnIcon />
                  </IconButton>
                </Tooltip>
                {selectedIds.length > 0 && (
                  <Tooltip title="Change Assignment" arrow>
                    <IconButton
                      onClick={() => setOpenAssignmentDialog(true)}
                      sx={{ color: '#0b85c8', padding: '8px' }}
                    >
                      <EditIcon />
                    </IconButton>
                  </Tooltip>
                )}
                {opencolspaper && (
                  <Paper
                    elevation={3}
                    sx={{
                      p: 2,
                      zIndex: 1300,
                      borderRadius: 2,
                      position: 'absolute',
                      top: { lg: '160px', xs: '255px', sm: '215px', md: '215px' },
                      right: '25px',
                      width: { xs: '280px', sm: '320px', md: '280px' },
                      maxWidth: '320px',
                      boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.2)',
                    }}
                  >
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
                      <Typography
                        variant="subtitle1"
                        sx={{
                          fontFamily: 'Open Sans',
                          fontWeight: 600,
                          color: '#0b85c8',
                          fontSize: { xs: '13px', sm: '14px', md: '15px' },
                        }}
                      >
                        Customize Columns
                      </Typography>
                      <IconButton onClick={() => setOpencolspaper(false)} size="small">
                        <CloseIcon fontSize="small" />
                      </IconButton>
                    </Box>
                    <Box sx={{ mb: 1 }}>
                      <Button
                        variant="text"
                        onClick={() => {
                          const allSelected = columns.every(column => !column.hide);
                          if (allSelected) {
                            const updatedColumns = columns.map(column => ({ ...column, hide: true }));
                            setColumns(updatedColumns);
                            setColumnOrder([]);
                          } else {
                            const updatedColumns = columns.map(column => ({ ...column, hide: false }));
                            setColumns(updatedColumns);
                            setColumnOrder(columns.map(column => column.field));
                          }
                        }}
                        sx={{
                          fontFamily: 'Open Sans',
                          fontSize: { xs: '11px', sm: '12px', md: '13px' },
                          textTransform: 'none',
                          color: '#0b85c8',
                          p: 0,
                          minWidth: 'auto',
                          '&:hover': {
                            backgroundColor: 'transparent',
                            textDecoration: 'underline'
                          }
                        }}
                      >
                        {columns.every(column => !column.hide) ? 'Unselect All' : 'Select All'}
                      </Button>
                    </Box>
                    <Box sx={{ maxHeight: 200, overflowY: 'auto' }}>
                      {columns.map((column) => (
                        <Box key={column.field} sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                          <Checkbox
                            checked={!column.hide}
                            onChange={(e) => {
                              const updatedColumns = columns.map((col) =>
                                col.field === column.field ? { ...col, hide: !e.target.checked } : col
                              );
                              setColumns(updatedColumns);
                              if (e.target.checked) {
                                setColumnOrder((prev) => {
                                  if (!prev.includes(column.field)) {
                                    return [...prev, column.field];
                                  }
                                  return prev;
                                });
                              } else {
                                setColumnOrder((prev) => prev.filter(field => field !== column.field));
                              }
                            }}
                            sx={{ mr: 1, p: 0.5 }}
                          />
                          <Typography
                            sx={{
                              fontFamily: 'Open Sans',
                              fontSize: { xs: '12px', sm: '13px', md: '14px' },
                            }}
                          >
                            {column.headerName || column.field}
                          </Typography>
                        </Box>
                      ))}
                    </Box>
                  </Paper>
                )}
              </Box>
            </Box>
          </Box>

          <Box sx={{ overflowX: 'auto', width: '100%' }}>
            <ReusableTable
              columns={filteredColumns}
              rows={filteredRows}
              onEdit={handleEdit}
              onDelete={handleDelete}
              editicon={editicon}
              deleteicon={deleteicon}
              onLeadNameClick={handleLeadNameClick}
              onPaginationChange={handlePaginationChange}
              totalrows={totalrows}
              onSelectionChange={(ids) => setSelectedIds(ids)}
              onApplyFilters={(activeFilters) => {
                setAppliedFilters(activeFilters);
              }}
            />
          </Box>

          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Dialog
              open={openLeadDialog}
              maxWidth="sm"
              fullWidth
              sx={{ borderRadius: 10 }}
              TransitionComponent={Grow}
              TransitionProps={{ timeout: 500 }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
                <DialogTitle
                  sx={{
                    fontFamily: 'Open Sans',
                    fontWeight: 600,
                    p: 2,
                    textAlign: 'center',
                    backgroundColor: '#f0f9ff',
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2,
                    color: '#0b85c8',
                    fontSize: { lg: '20px', xs: '10px', sm: '13px', md: '18px' },
                    margin: 'auto'
                  }}
                >
                  {editingLeadId ? "Edit Lead Details" : "Add New Lead Details to Grow Your Pipeline"}
                </DialogTitle>
                <IconButton onClick={() => setOpenLeadDialog(false)} sx={{ color: '#ffff' }}>
                  <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: { lg: "24px" }, borderRadius: 2, color: '#fffff', mr: 2 }} />
                </IconButton>
              </Box>

              <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff', mt: -1 }}>
                <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                  <Typography fontWeight={600} mb={1} mt={2} ml={2}>Lead Details</Typography>
                  <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                    <TextField
                      label="Lead name"
                      name="leadName"
                      value={formData.leadName}
                      size="small"
                      onChange={handleInputChange}
                      fullWidth
                      sx={{ width: { lg: '96%' } }}
                      error={!!errors.leadName}
                      helperText={errors.leadName}
                    />
                  </Grid>
                </Box>
                <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                  <Typography fontWeight={600} mb={1} mt={2} ml={2}>Personal Details</Typography>
                  <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                    <TextField label="Full Name" name="fullName" value={formData.fullName} onChange={handleInputChange} size='small' fullWidth sx={{ width: { lg: '45%', md: '49%' } }} error={!!errors.fullName} helperText={errors.fullName} />
                    <TextField label="Email" name="email" value={formData.email} onChange={handleInputChange} size='small' fullWidth sx={{ width: { lg: '45%', md: '49%' } }} error={!!errors.email} helperText={errors.email} />
                    <TextField label="Phone Number" name="phone" value={formData.phone} onChange={handleInputChange} size='small' fullWidth sx={{ width: { lg: '45%', md: '49%' } }} error={!!errors.phone} helperText={errors.phone} />
                    <TextField label="Alternate Number" name="alternateNumber" value={formData.alternateNumber} size='small' onChange={handleInputChange} fullWidth sx={{ width: { lg: '45%', md: '49%' } }} />
                    <TextField label="Address" name="address" value={formData.address} onChange={handleInputChange} size='small' fullWidth sx={{ width: { lg: "96%" } }} />
                    <TextField
                      select
                      label="Country"
                      name="country"
                      value={formData.country}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                    >
                      <MenuItem value="" disabled>Select Country</MenuItem>
                      {countries.map((country) => (
                        <MenuItem key={country.id} value={country.id}>
                          {country.name}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      select
                      label="State"
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                    >
                      <MenuItem value="" disabled>Select State</MenuItem>
                      {states
                        .filter(state => state.country_id === parseInt(formData.country))
                        .map((state) => (
                          <MenuItem key={state.id} value={state.id}>
                            {state.name}
                          </MenuItem>
                        ))}
                    </TextField>
                    <TextField
                      select
                      label="City"
                      name="city"
                      value={formData.city}
                      onChange={handleInputChange}
                      fullWidth
                      size="small"
                      sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }}
                    >
                      <MenuItem value="" disabled>Select City</MenuItem>
                      {cities
                        .filter(city => city.state_id === parseInt(formData.state))
                        .map((city) => (
                          <MenuItem key={city.id} value={city.id}>
                            {city.name}
                          </MenuItem>
                        ))}
                    </TextField>
                    <TextField label="Zip Code" name="zipCode" value={formData.zipCode} onChange={handleInputChange} size='small' fullWidth sx={{ width: { xs: '100%', sm: '100%', lg: '45%' } }} />
                  </Grid>
                </Box>
                <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                  <Typography fontWeight={600} mb={1} mt={2} ml={2}>Lead Source Tracking</Typography>
                  <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                    <TextField
                      select
                      label="Source Type"
                      name="sourceType"
                      value={formData.sourceType}
                      size="small"
                      onChange={handleInputChange}
                      fullWidth
                      sx={{ width: { lg: '96%' } }}
                    >
                      {sourceTypeData?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    {formData.sourceType !== "self" && formData.sourceType && (
                      <TextField
                        label="Source Channel"
                        name="sourceChannel"
                        value={formData.sourceChannel}
                        size="small"
                        onChange={handleInputChange}
                        fullWidth
                        sx={{ width: { lg: '96%' } }}
                      />
                    )}
                  </Grid>
                </Box>
                <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                  <Typography fontWeight={600} mb={1} mt={2} ml={2}>Lead Status & Assignment</Typography>
                  <Grid container spacing={1} sx={{ display: 'flex', flexDirection: 'row', flexGrow: 1, justifyContent: 'space-around', mb: 2 }}>
                    <TextField
                      select
                      label="Interest Level"
                      name="interestLevel"
                      value={formData.interestLevel}
                      onChange={handleInputChange}
                      size="small"
                      fullWidth
                      sx={{ width: { lg: '45%', md: '49%' } }}
                    >
                      {interestLevelData?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      select
                      label="Lead Stage"
                      name="leadStage"
                      value={formData.leadStage}
                      onChange={handleInputChange}
                      size="small"
                      fullWidth
                      sx={{ width: { lg: '45%', md: '49%' } }}
                    >
                      {leadStageData?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.value}
                        </MenuItem>
                      ))}
                    </TextField>
                    <TextField
                      label="Assigned To"
                      select
                      name="assignedTo"
                      value={formData.assignedTo}
                      onChange={handleInputChange}
                      size='small'
                      fullWidth
                      sx={{ width: { lg: '96%', md: '96%' } }}
                    >
                      {employeelist?.map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.employee_name}
                        </MenuItem>
                      ))}
                    </TextField>
                    {/* <DatePicker
                      label="Assigned On"
                      value={formData.assignedOn}
                      onChange={(date) => handleDateChange('assignedOn', date)}
                      inputFormat="dd/MM/yyyy"
                      format='dd/MM/yyy'
                      sx={{ width: { lg: '45%', md: '49%', sm: '100%' } }}
                      slotProps={{
                        textField: {
                          size: 'small',
                          sx: {
                            '& .MuiInputBase-root': { height: 36 },
                            width: { lg: '45%', md: '49%', sm: '100%' }
                          }
                        }
                      }}
                    /> */}
                  </Grid>
                </Box>
                <Box sx={{ borderRadius: 2, boxShadow: '1px 1px 10px #888', fontFamily: 'Open Sans', padding: 2, backgroundColor: '#ffffff', ml: 1, position: 'relative', marginBottom: '15px' }}>
                  <Typography fontWeight={600} mb={1} mt={2} ml={2}>Notes and Comments</Typography>
                  <TextField
                    label="Notes"
                    name="notes"
                    value={formData.notes}
                    onChange={handleInputChange}
                    size="small"
                    multiline
                    rows={4}
                    fullWidth
                    sx={{ width: { lg: '96%' }, ml: { lg: 2 } }}
                  />
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{ mt: 2, backgroundColor: '#0b85c8', fontFamily: 'Open Sans', width: 'max-content', margin: 'auto' }}
                    onClick={handleLeadSubmit}
                  >
                    {getLeadButtonLabel(editingLeadId, tab.value)}
                  </Button>
                </Box>
              </DialogContent>
            </Dialog>

            <Dialog
              open={openCustomDialog}
              onClose={handleCloseCustomDialog}
              maxWidth="sm"
              fullWidth
              sx={{ borderRadius: 10 }}
              TransitionComponent={Grow}
              TransitionProps={{ timeout: 500 }}
            >
              <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#f0f9ff' }}>
                <DialogTitle
                  sx={{
                    fontFamily: 'Open Sans',
                    fontWeight: 600,
                    p: 2,
                    textAlign: 'center',
                    backgroundColor: '#f0f9ff',
                    display: 'flex',
                    justifyContent: 'center',
                    mt: 2,
                    color: '#0b85c8',
                    fontSize: { lg: '20px', xs: '10px', sm: '13px', md: '18px' },
                    margin: 'auto'
                  }}
                >
                  {selectedLead?.lead_name}
                </DialogTitle>
                <IconButton onClick={handleCloseCustomDialog} sx={{ color: '#ffff' }}>
                  <CloseIcon sx={{ backgroundColor: '#0b85c8', fontSize: { lg: '24px' }, borderRadius: 2, color: '#fffff', mr: 2 }} />
                </IconButton>
              </Box>
              <DialogContent sx={{ fontFamily: 'Open Sans', backgroundColor: '#f0f9ff' }}>
                {selectedLead ? (
                  <Box sx={{ borderRadius: 10 }} >
                    <Accordion sx={{ mb: 2, borderRadius: 2, boxShadow: '1px 1px 10px #888' }} >
                      <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        sx={{
                          fontFamily: 'Open Sans',
                          fontWeight: 600,
                          fontSize: { lg: '14px', md: '12px', xs: '10px', sm: '11px' },
                        }}
                      >
                        Lead Data
                      </AccordionSummary>
                      <AccordionDetails sx={{ mt: -2 }}>
                        <TableContainer component={Paper}>
                          <Table size="small">
                            <TableBody>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>
                                  Lead Name
                                </TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.lead_name || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Full Name</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.full_name || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Email</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.email || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Phone</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.phone || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Source Type</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.source_type || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Interest Level</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.interest_level || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Lead Stage</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.lead_stage || '-'}</TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>Assigned To</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontSize: { xs: '10px', sm: '13px', md: '14px', lg: '15px' } }}>{selectedLead.assigned_to || '-'}</TableCell>
                              </TableRow>
                            </TableBody>
                          </Table>
                        </TableContainer>
                      </AccordionDetails>
                    </Accordion>
                    <Paper sx={{ p: 2, borderRadius: 2, boxShadow: '1px 1px 10px #888', mb: 2 }}>
                      <Typography variant="h6" sx={{ fontFamily: 'Open Sans', fontWeight: 600, mb: 2, textAlign: 'center' }}>
                        Follow-Ups
                      </Typography>
                      {followUps.length > 0 ? (
                        <TableContainer component={Paper} sx={{ mb: 2 }}>
                          <Table size="small">
                            <TableHead>
                              <TableRow>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>S.No</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>Assigned To</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>Follow-Up Date</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>Status</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>Next Follow-Up</TableCell>
                                <TableCell sx={{ fontFamily: 'Open Sans', fontWeight: 600, bgcolor: '#f0f9ff', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>Notes</TableCell>
                              </TableRow>
                            </TableHead>
                            <TableBody>
                              {followUps.map((followUp, index) => (
                                <TableRow key={followUp.id} sx={{ textWrap: 'nowrap' }}>
                                  <TableCell sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>{index + 1}</TableCell>
                                  <TableCell sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>{followUp.employee_name || '-'}</TableCell>
                                  <TableCell sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>{followUp.followUpDate || '-'}</TableCell>
                                  <TableCell sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>{followUp.status || '-'}</TableCell>
                                  <TableCell sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>{followUp.nextFollowUpDate || '-'}</TableCell>
                                  <TableCell sx={{ fontFamily: 'Open Sans', textWrap: 'nowrap', fontSize: { xs: '10px', sm: '11px', md: '12px', lg: '12px' } }}>{followUp.notes || '-'}</TableCell>
                                </TableRow>
                              ))}
                            </TableBody>
                          </Table>
                        </TableContainer>
                      ) : (
                        <Typography sx={{ fontFamily: 'Open Sans', mb: 2, textAlign: 'center' }}>
                          No follow-ups found for this lead.
                        </Typography>
                      )}
                    </Paper>
                  </Box>
                ) : (
                  <Typography sx={{ fontFamily: 'Open Sans' }}>No lead selected</Typography>
                )}
              </DialogContent>
            </Dialog>

            <Dialog
              open={openAssignmentDialog}
              onClose={() => setOpenAssignmentDialog(false)}
              maxWidth="xs"
              fullWidth
              TransitionComponent={Grow}
              TransitionProps={{ timeout: 500 }}
            >
              <DialogTitle sx={{ fontWeight: 600, color: '#0b85c8', textAlign: 'center', fontFamily: 'Open Sans', bgcolor: '#f0f9ff' }}>Change Assignment</DialogTitle>
              <DialogContent sx={{ bgcolor: '#f0f9ff' }}>
                <Autocomplete
                  options={employeelist}
                  getOptionLabel={(option) => option.employee_name}
                  value={selectedEmployee}
                  onChange={(event, newValue) => setSelectedEmployee(newValue)}
                  renderInput={(params) => <TextField {...params} label="Assigned To" size="small" />}
                  sx={{ mt: 2 }}
                />
              </DialogContent>
              <DialogActions sx={{ bgcolor: '#f0f9ff' }}>
                <Button
                  variant="contained"
                  onClick={handleBulkAssignment}
                  disabled={!selectedEmployee}
                  sx={{ bgcolor: '#0b85c8', margin: 'auto', mb: 1, borderRadius: 2 }}
                >
                  Update
                </Button>
              </DialogActions>
            </Dialog>
          </LocalizationProvider>
        </>
      ) : (
        <FollowUps />
      )}
    </Container>
  );
}